import type { TimeRangePreset } from '../../../shared/components/TimeRangeSelect';

export const ACTION_LOG_PRESETS: TimeRangePreset[] = [
  { value: 'all', label: 'All time' },
  { value: '24h', label: 'Last 24 hours' },
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '90d', label: 'Last 90 days' },
];

const PRESET_MS: Record<string, number> = {
  '24h': 24 * 60 * 60 * 1000,
  '7d': 7 * 24 * 60 * 60 * 1000,
  '30d': 30 * 24 * 60 * 60 * 1000,
  '90d': 90 * 24 * 60 * 60 * 1000,
};

/** Whether a timestamp falls within the selected preset window, or the custom
 *  from/to range when no preset is active. The action log is a small, bounded
 *  set, so this filters the loaded incidents client-side. */
export function withinTimeRange(
  iso: string,
  timeRange: string | undefined,
  startTime: string | undefined,
  endTime: string | undefined,
): boolean {
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return true;

  if (!timeRange) {
    if (startTime && t < new Date(startTime).getTime()) return false;
    if (endTime && t > new Date(endTime).getTime()) return false;
    return true;
  }

  if (timeRange === 'all') return true;
  const span = PRESET_MS[timeRange];
  if (!span) return true;
  return t >= Date.now() - span;
}
